<div class="loader">
  <img src="./assets/images/mortgage_loader_new.gif" />
</div>
